(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["navbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desktop-navigation')) {
    class DesktopNavigation extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.buttons = [...this.querySelectorAll('.desktop-navigation__toggle')];
        this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

        for (const button of this.buttons) {
          button.addEventListener('click', () => this.toggle(button), { signal: this.controller.signal });

          const item = button.closest('[data-navigation-item]');
          item.addEventListener('mouseenter', () => {
            if (this.hoverQuery.matches) this.open(button);
          }, { signal: this.controller.signal });
          item.addEventListener('mouseleave', () => {
            if (this.hoverQuery.matches) this.close(button);
          }, { signal: this.controller.signal });
        }

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.closeAll();
        }, { signal: this.controller.signal });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const openButton = this.querySelector('.desktop-navigation__toggle[aria-expanded="true"]');
          if (!openButton) return;
          this.close(openButton);
          openButton.focus();
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      toggle(button) {
        if (button.hasAttribute('data-click-open')) {
          this.close(button);
          return;
        }
        this.open(button);
        button.setAttribute('data-click-open', '');
      }

      open(button) {
        this.closeAll(button);
        const submenu = document.getElementById(button.getAttribute('aria-controls'));
        if (!submenu) return;
        button.setAttribute('aria-expanded', 'true');
        button.closest('[data-navigation-item]')?.setAttribute('data-open', '');
        submenu.hidden = false;
      }

      close(button) {
        const submenu = document.getElementById(button.getAttribute('aria-controls'));
        button.setAttribute('aria-expanded', 'false');
        button.removeAttribute('data-click-open');
        button.closest('[data-navigation-item]')?.removeAttribute('data-open');
        if (submenu) submenu.hidden = true;
      }

      closeAll(exceptButton) {
        for (const button of this.buttons) {
          if (button !== exceptButton) this.close(button);
        }
      }
    }

    customElements.define('desktop-navigation', DesktopNavigation);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-collections-mirror"] && !Shopify.designMode) return;
  try {
    
class SimpleCollectionsFlyout extends HTMLElement {
  connectedCallback() {
    for (const [index, item] of [...this.querySelectorAll('.simple-collections-item')].entries()) {
      item.style.setProperty('--simple-collection-index', index + 1);
    }
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      toggle.hidden = !panel?.querySelector('.simple-collections__subcategory[href]');
    }
    this.toggleClicked = (event) => this.handleToggle(event);
    this.keyPressed = (event) => this.handleKeydown(event);
    this.panelTransitioned = (event) => this.handleTransitionEnd(event);
    this.viewportResized = () => this.updateOpenWidth();
    this.pageShown = () => {
      const currentToggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
      if (currentToggle) requestAnimationFrame(() => this.revealToggle(currentToggle));
    };
    this.addEventListener('click', this.toggleClicked);
    this.addEventListener('keydown', this.keyPressed);
    this.addEventListener('transitionend', this.panelTransitioned);
    window.addEventListener('resize', this.viewportResized);
    window.addEventListener('pageshow', this.pageShown);
    this.openCurrentParent();
  }
  openCurrentParent() {
    const currentLink = this.querySelector('.simple-collections__parent-link[aria-current="page"]')
      || this.querySelector('.simple-collections__subcategory[aria-current="page"]');
    const currentPanel = currentLink?.closest('.simple-collections-item')?.querySelector('[data-subcategories-panel]');
    if (!currentPanel?.querySelector('.simple-collections__subcategory[href]')) return;
    const currentToggle = this.querySelector(`[aria-controls="${CSS.escape(currentPanel.id)}"]`);
    if (!currentToggle) return;
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (panel) this.setPanelState(toggle, panel, toggle === currentToggle, true);
    }
    requestAnimationFrame(() => this.revealToggle(currentToggle));
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.toggleClicked);
    this.removeEventListener('keydown', this.keyPressed);
    this.removeEventListener('transitionend', this.panelTransitioned);
    window.removeEventListener('resize', this.viewportResized);
    window.removeEventListener('pageshow', this.pageShown);
  }
  handleToggle(event) {
    const toggle = event.target.closest('.simple-collections__parent-toggle');
    if (!toggle || !this.contains(toggle)) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    if (!panel.querySelector('.simple-collections__subcategory[href]')) {
      window.location.assign(toggle.dataset.parentUrl);
      return;
    }
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    for (const parentToggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const parentPanel = this.querySelector(`#${CSS.escape(parentToggle.getAttribute('aria-controls'))}`);
      if (parentPanel) this.setPanelState(parentToggle, parentPanel, opening && parentToggle === toggle);
    }
    if (opening) this.revealToggle(toggle);
  }
  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    event.preventDefault();
    this.setPanelState(toggle, panel, false);
    toggle.focus();
  }
  revealToggle(toggle) {
    const item = toggle.closest('.shopify-block');
    if (!item) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = Math.max(0, this.scrollLeft + item.getBoundingClientRect().left - this.getBoundingClientRect().left - 16);
    this.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  setPanelState(toggle, panel, opening, instant = false) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (instant) panel.style.transition = 'none';
    if (opening) {
      const wasHidden = panel.hidden;
      panel.hidden = false;
      panel.inert = false;
      if (wasHidden && !instant && !reducedMotion) {
        panel.style.width = '0px';
        panel.offsetWidth;
      }
    } else {
      panel.inert = true;
    }
    toggle.setAttribute('aria-expanded', String(opening));
    panel.style.width = opening ? `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px` : '0px';
    if (!opening && (instant || reducedMotion || panel.getBoundingClientRect().width === 0)) panel.hidden = true;
    if (instant) {
      panel.offsetWidth;
      requestAnimationFrame(() => panel.style.removeProperty('transition'));
    }
  }
  handleTransitionEnd(event) {
    const panel = event.target;
    if (!panel.matches?.('[data-subcategories-panel]') || event.propertyName !== 'width') return;
    const toggle = this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
    if (toggle?.getAttribute('aria-expanded') === 'false') panel.hidden = true;
  }
  updateOpenWidth() {
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (panel) panel.style.width = `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px`;
  }
}
if (!customElements.get('vhalam-collection-flyout')) customElements.define('vhalam-collection-flyout', SimpleCollectionsFlyout);

class VhalamCategoryMirror extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.load();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async load() {
    const endpoint = new URL(this.dataset.sourceUrl, window.location.origin);
    endpoint.searchParams.set('section_id', this.dataset.sourceSection);
    const previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewThemeId) endpoint.searchParams.set('preview_theme_id', previewThemeId);

    try {
      const response = await fetch(endpoint, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: this.controller.signal
      });
      let categories;
      if (response.ok) {
        const documentFromHome = new DOMParser().parseFromString(await response.text(), 'text/html');
        categories = documentFromHome.querySelector('.simple-collections');
      }
      if (!categories?.querySelector('vhalam-collection-flyout')) {
        endpoint.searchParams.delete('section_id');
        const homepageResponse = await fetch(endpoint, {
          credentials: 'same-origin',
          cache: 'no-store',
          signal: this.controller.signal
        });
        if (!homepageResponse.ok) throw new Error('Shared categories unavailable');
        const documentFromHome = new DOMParser().parseFromString(await homepageResponse.text(), 'text/html');
        categories = documentFromHome.querySelector('.simple-collections');
      }
      if (!categories?.querySelector('vhalam-collection-flyout')) throw new Error('Homepage category section missing');

      const currentPath = window.location.pathname.replace(/\/+$/, '');
      for (const link of categories.querySelectorAll('.simple-collections__parent-link[href], .simple-collections__subcategory[href]')) {
        const linkPath = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '');
        if (linkPath !== currentPath) continue;
        link.setAttribute('aria-current', 'page');
        if (link.classList.contains('simple-collections__parent-link')) {
          const item = link.closest('.simple-collections-item');
          item?.classList.add('active');
          item?.setAttribute('data-current-parent', '');
        }
      }

      this.replaceChildren(categories);
      this.setAttribute('aria-busy', 'false');
      requestAnimationFrame(() => {
        if (categories.isConnected) categories.classList.add('viewport-entered');
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      this.querySelector('[data-category-mirror-fallback]')?.removeAttribute('hidden');
      this.setAttribute('aria-busy', 'false');
      console.error('Shared homepage categories could not load', error);
    }
  }
}

if (!customElements.get('vhalam-category-mirror')) customElements.define('vhalam-category-mirror', VhalamCategoryMirror);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["simple-collections"] && !Shopify.designMode) return;
  try {
    
class SimpleCollectionsFlyout extends HTMLElement {
  connectedCallback() {
    for (const [index, item] of [...this.querySelectorAll('.simple-collections-item')].entries()) {
      item.style.setProperty('--simple-collection-index', index + 1);
    }
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      toggle.hidden = !panel?.querySelector('.simple-collections__subcategory[href]');
    }
    this.toggleClicked = (event) => this.handleToggle(event);
    this.keyPressed = (event) => this.handleKeydown(event);
    this.panelTransitioned = (event) => this.handleTransitionEnd(event);
    this.viewportResized = () => this.updateOpenWidth();
    this.pageShown = () => {
      const currentToggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
      if (currentToggle) requestAnimationFrame(() => this.revealToggle(currentToggle));
    };
    this.addEventListener('click', this.toggleClicked);
    this.addEventListener('keydown', this.keyPressed);
    this.addEventListener('transitionend', this.panelTransitioned);
    window.addEventListener('resize', this.viewportResized);
    window.addEventListener('pageshow', this.pageShown);
    this.openCurrentParent();
  }
  openCurrentParent() {
    const currentLink = this.querySelector('.simple-collections__parent-link[aria-current="page"]')
      || this.querySelector('.simple-collections__subcategory[aria-current="page"]');
    const currentPanel = currentLink?.closest('.simple-collections-item')?.querySelector('[data-subcategories-panel]');
    if (!currentPanel?.querySelector('.simple-collections__subcategory[href]')) return;
    const currentToggle = this.querySelector(`[aria-controls="${CSS.escape(currentPanel.id)}"]`);
    if (!currentToggle) return;
    for (const toggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
      if (panel) this.setPanelState(toggle, panel, toggle === currentToggle, true);
    }
    requestAnimationFrame(() => this.revealToggle(currentToggle));
  }
  disconnectedCallback() {
    this.removeEventListener('click', this.toggleClicked);
    this.removeEventListener('keydown', this.keyPressed);
    this.removeEventListener('transitionend', this.panelTransitioned);
    window.removeEventListener('resize', this.viewportResized);
    window.removeEventListener('pageshow', this.pageShown);
  }
  handleToggle(event) {
    const toggle = event.target.closest('.simple-collections__parent-toggle');
    if (!toggle || !this.contains(toggle)) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    if (!panel.querySelector('.simple-collections__subcategory[href]')) {
      window.location.assign(toggle.dataset.parentUrl);
      return;
    }
    const opening = toggle.getAttribute('aria-expanded') !== 'true';
    for (const parentToggle of this.querySelectorAll('.simple-collections__parent-toggle')) {
      const parentPanel = this.querySelector(`#${CSS.escape(parentToggle.getAttribute('aria-controls'))}`);
      if (parentPanel) this.setPanelState(parentToggle, parentPanel, opening && parentToggle === toggle);
    }
    if (opening) this.revealToggle(toggle);
  }
  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (!panel) return;
    event.preventDefault();
    this.setPanelState(toggle, panel, false);
    toggle.focus();
  }
  revealToggle(toggle) {
    const item = toggle.closest('.shopify-block');
    if (!item) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const target = Math.max(0, this.scrollLeft + item.getBoundingClientRect().left - this.getBoundingClientRect().left - 16);
    this.scrollTo({ left: target, behavior: reducedMotion ? 'auto' : 'smooth' });
  }
  setPanelState(toggle, panel, opening, instant = false) {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (instant) panel.style.transition = 'none';
    if (opening) {
      const wasHidden = panel.hidden;
      panel.hidden = false;
      panel.inert = false;
      if (wasHidden && !instant && !reducedMotion) {
        panel.style.width = '0px';
        panel.offsetWidth;
      }
    } else {
      panel.inert = true;
    }
    toggle.setAttribute('aria-expanded', String(opening));
    panel.style.width = opening ? `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px` : '0px';
    if (!opening && (instant || reducedMotion || panel.getBoundingClientRect().width === 0)) panel.hidden = true;
    if (instant) {
      panel.offsetWidth;
      requestAnimationFrame(() => panel.style.removeProperty('transition'));
    }
  }
  handleTransitionEnd(event) {
    const panel = event.target;
    if (!panel.matches?.('[data-subcategories-panel]') || event.propertyName !== 'width') return;
    const toggle = this.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
    if (toggle?.getAttribute('aria-expanded') === 'false') panel.hidden = true;
  }
  updateOpenWidth() {
    const toggle = this.querySelector('.simple-collections__parent-toggle[aria-expanded="true"]');
    if (!toggle) return;
    const panel = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
    if (panel) panel.style.width = `${panel.querySelector('.simple-collections__subcategory-list').scrollWidth}px`;
  }
}
if (!customElements.get('vhalam-collection-flyout')) customElements.define('vhalam-collection-flyout', SimpleCollectionsFlyout);

  } catch(e) { console.error(e); }
})();
})();
